export class Limit {
  id?: number;
  name: string;
  transactions_daily: number;
  amount_daily: number;
  amount_weekly: number;
  amount_monthly: number;
  quantitative_daily: number;
  quantitative_weekly: number;
  quantitative_monthly: number;
  no_fuel_daily: number;
  no_fuel_weekly: number;
  no_fuel_monthly: number;
  fleet_group_ids: number[];

  constructor(opts?: Limit) {
    Object.assign(this as Object, opts || {});
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/model/limit.ts